import React from "react";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import { useHistory } from "react-router-dom";
import planImage from "../../../../assets/images/breakeven.png";
export const PayOffDetails = (props) => {
  const history = useHistory();

  function calculateRemainingYearsAndMonths(maturityDate) {
    const currentDate = new Date();
    maturityDate = new Date(maturityDate);
    if (currentDate.getTime() === maturityDate.getTime()) {
      return "Maturity date is today";
    } else {
      const differenceMs = maturityDate - currentDate;
      const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
      const millisecondsInMonth = millisecondsInYear / 12;
      const remainingYears = Math.floor(differenceMs / millisecondsInYear);
      const remainingMonths = Math.floor(
        (differenceMs % millisecondsInYear) / millisecondsInMonth
      );

      return formatRemainingYearsAndMonths(remainingYears, remainingMonths);
    }
  }
  function formatRemainingYearsAndMonths(remainingYears, remainingMonths) {
    if (remainingYears === 0) {
      return `${remainingMonths} months`;
    } else if (remainingYears === 1 && remainingMonths === 0) {
      return `${remainingYears} year`;
    } else if (remainingYears === 1) {
      return `${remainingYears} year, ${remainingMonths} months`;
    } else if (remainingMonths === 0) {
      return `${remainingYears} years`;
    } else {
      return `${remainingYears} years, ${remainingMonths} months`;
    }
  }
  // function getMinMaturityDate(data) {
  //   let filterData=data ;
  //   if (filterData.length === 0) {
  //     return null; // Return null if data is empty
  //   }

  //   const currentDate = new Date();

  //   let minDate = new Date(filterData[0]["Maturity Date"] || currentDate);
  //   for (let i = 1; i < filterData.length; i++) {
  //     const maturityDate = new Date(filterData[i]["Maturity Date"]);
  //     if (maturityDate < minDate && maturityDate >= currentDate) {
  //       minDate = maturityDate;
  //     }
  //   }
  //   return calculateRemainingYearsAndMonths(minDate);
  // }
  function getMinMaturityDate(data) {
    let filterData = data;
    if (filterData.length === 0) {
      return null; // Return null if data is empty
    }

    const currentDate = new Date();

    let minDate = null; // Initialize with null
    for (let i = 0; i < filterData.length; i++) {
      const maturityDate = new Date(filterData[i]["Maturity Date"]);
      if (
        maturityDate > currentDate &&
        (minDate === null || maturityDate < minDate)
      ) {
        minDate = maturityDate;
      }
    }

    if (minDate === null) {
      return null; // Return null if no valid maturity date found
    }
    console.log("minDate", minDate);
    return calculateRemainingYearsAndMonths(minDate);
  }

  function getMaxMaturityDate(data) {
    let filterData = data;

    if (filterData.length === 0) {
      return null; // Return null if data is empty
    }
    const TodaysDate = new Date();
    let minDate = new Date(filterData[0]["Maturity Date"] || TodaysDate);

    for (let i = 1; i < filterData.length; i++) {
      const currentDate = new Date(filterData[i]["Maturity Date"]);
      if (currentDate > minDate) {
        minDate = currentDate;
      }
    }
    console.log("maxDate", minDate);
    return calculateRemainingYearsAndMonths(minDate);
  }
  function calculateInterestPaid(data) {
    let filterData = data;

    let totalInterestPaid = 0;

    for (let i = 0; i < filterData.length; i++) {
      const loan = filterData[i];
      const initialLoanAmount = loan["Initial Loan Amount"];
      const interestRate = loan["Interest Rate"];
      const monthlyInterestRate = interestRate / 12;
      const interestPaid = initialLoanAmount * monthlyInterestRate;
      totalInterestPaid += interestPaid;
    }
    if (totalInterestPaid) {
      return `${
        "$" +
        totalInterestPaid
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }`;
    } else {
      return 0;
    }
  }
  const detailsData = [
    {
      id: 1,
      name: "Next Debt Payoff",
      time: props && props.data && getMinMaturityDate(props.data),
    },
    {
      id: 2,
      name: "All Debt Payoff",
      time: props && props.data && getMaxMaturityDate(props.data),
    },
    {
      id: 3,
      name: "Total Interest Paid",
      time: props && props.data && calculateInterestPaid(props.data),
    },
  ];
  return (
    <div style={{ position: "relative" }}>
      {" "}
      <div
        className="cardHeadingDebt"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "4px",
        }}
      >
        Debt Payoff Details
        <button
          className="addbuttonLiablity"
          onClick={() => {
            history.push({
              pathname: "/strategy",
              total: props.valueTotal && props.valueTotal,
            });
          }}
        >
          {" "}
          Compare Plans
        </button>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap:"8px"
        }}
      >
        <div className="" style={{width:"50%",
        // maxHeight: "15rem",
        display: "flex",
        flexDirection: "column",
        marginTop: "1rem",}}>
          <React.Fragment>
            <div className="list-row-no">
              <div className="listname-dark">
                <div>Current Selected Plan:</div>
                {props.selectedPlan && props.selectedPlan ? (
                  <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                    {props.selectedPlan}
                  </div>
                ) : (
                  <div className="nodata" style={{marginTop:"1rem"}}>No Plan Seleted</div>
                )}
              </div>
            </div>
            <div>
            <img
              src={planImage}
              style={{ width: "60%", height: "100%" }}
              alt="image"
            />
            </div>
          </React.Fragment>
        </div>
        <div className="listingContainer" style={{justifyContent:"space-between",maxHeight:"auto",}} >
          <React.Fragment>
            {detailsData && detailsData.length > 0 ? (
              detailsData.map((item, index) => (
                <div key={index} className="list-row-no" style={{marginTop:"0"}}>
                  <div className="listname-dark">
                    <div>{item.name}</div>
                    <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                      {item.time}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="nodata">No Data to Show</div>
            )}
          </React.Fragment>
        </div>
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
